import { render } from "./RelatedMovie.vue?vue&type=template&id=8fa60044&scoped=true"
import script from "./RelatedMovie.vue?vue&type=script&lang=js"
export * from "./RelatedMovie.vue?vue&type=script&lang=js"

import "./RelatedMovie.vue?vue&type=style&index=0&id=8fa60044&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fa60044"]])

export default __exports__